import Store from 'store';

export function embedFix(embed) {
  embed = {...embed};
  if (embed.items) {
    embed.items = {...embed.items};
    if (embed.items.ring1?.engraving_extra) {
      embed.items.ring1 = {...embed.items.ring1};
      embed.engraving1 = Object.entries(embed.items.ring1.engraving_extra).map(([id, points]) => ({id, points}))[0];
      delete embed.items.ring1.engraving_extra;
    }
    if (embed.items.ring2?.engraving_extra) {
      embed.items.ring2 = {...embed.items.ring2};
      embed.engraving2 = Object.entries(embed.items.ring2.engraving_extra).map(([id, points]) => ({id, points}))[0];
      delete embed.items.ring2.engraving_extra;
    }
  }
  if (embed.type === 'skills' && embed.data) {
    function makeData(levels) {
      const data = {...embed.data};
      for (const [id, level] of Object.entries(levels)) {
        data[id] = {...data[id], level};
      }
      return data;
    }
    if (embed.history) {
      embed.steps = [];
      for (const h of embed.history) {
        const levels = {...h.start};
        embed.steps.push(makeData(levels));
        if (h.steps) for (const id of h.steps) {
          levels[id] = (levels[id] || 0) + 1;
          embed.steps.push(makeData(levels));
        }
      }
      delete embed.history;
    }
    if (embed.levels) {
      embed.data = makeData(embed.levels);
      delete embed.levels;
    }
  }
  return embed;
}

export function stateFix(state, importId, userId) {
  const result = {...Store.initialState, ...state, id: Store.newId()};
  if (!result.embeds[result.activeEmbed]) {
    result.activeEmbed = -1;
  }
  result.embeds = result.embeds.map(embed => embedFix(embed));
  if (importId) {
    result.imported = true;
    result.importedId = importId;
    result.user = userId;
  }
  return result;
}

export function stateSetImported(state, id, userId, name) {
  state = {...state, imported: true, importedId: id, user: userId};
  if (name) state.name = name;
  return state;
}

export function stateDeleteImports(state, ...ids) {
  if (ids.includes(state.importedId)) {
    state = {...state};
    if (ids.includes(state.importedId)) {
      delete state.imported;
      delete state.importedId;
      delete state.user;
    }
  }
  return state;
}
